import { gql } from "apollo-boost";

export const ROOT = gql`
  {
    isLoggedIn @client
    theme @client
  }
`;
